/**
 * Represents where within the containing element to draw the drop indicator
 */
export var ListDropIndicatorPosition;
(function (ListDropIndicatorPosition) {
    ListDropIndicatorPosition["bottom"] = "bottom";
    ListDropIndicatorPosition["top"] = "top";
    ListDropIndicatorPosition["left"] = "left";
    ListDropIndicatorPosition["right"] = "right";
})(ListDropIndicatorPosition || (ListDropIndicatorPosition = {}));
